import React from "react";
import AppLayout from "../components/AppLayout";
import CalendarSubscriptionCard from "../components/CalendarSubscriptionCard";
import { useI18n } from "../contexts/I18nContext";
import { useAuth } from "../contexts/AuthContext";

export default function Settings() {
  const { t, lang, setLang, languages } = useI18n();
  const { user, logout } = useAuth();
  return (
    <AppLayout>
      <h1 className="font-heading text-3xl sm:text-4xl font-black">{t("settings")}</h1>
      <div className="mt-8 max-w-2xl space-y-6">
        <div className="pp-card-elevated p-6" data-testid="settings-language">
          <h3 className="font-heading text-xl font-bold">{t("language")}</h3>
          <p className="text-zinc-400 text-sm mt-1">Pick2Play supports 9 languages including Arabic (RTL).</p>
          <select value={lang} onChange={(e) => setLang(e.target.value)} className="pp-input mt-4 max-w-xs" data-testid="settings-lang-select">
            {languages.map((l) => <option key={l.code} value={l.code}>{l.name} · {l.code.toUpperCase()}</option>)}
          </select>
        </div>
        <CalendarSubscriptionCard />
        <div className="pp-card-elevated p-6">
          <h3 className="font-heading text-xl font-bold">Account</h3>
          <div className="text-sm text-zinc-400 mt-2">Signed in as <span className="text-white">{user?.email}</span> · role <span className="text-white">{user?.role}</span></div>
          <button onClick={logout} data-testid="settings-logout" className="mt-4 pp-btn-secondary px-5 py-2 rounded-lg text-sm">{t("logout")}</button>
        </div>
      </div>
    </AppLayout>
  );
}
